import axios from 'axios';

export const S3_URL = 'https://gpvapi-store.s3-ap-southeast-2.amazonaws.com';

export const imageURL = (deviceId, fileName) => `${S3_URL}/devices/${deviceId}/images/${fileName}`;



// AUTH
// User => Login
export async function login(data={
  email: '',
  password: ''
}) {
  const res = await axios.post('/login', data);
  return res.data.data;
}

// User => Get Own Account
export async function getAccount() {
  const res = await axios.get('/user');
  return res.data.data;
}

// User => Update User
export async function updateUser(userId, data) {
  const res = await axios.put(`/users/${userId}`, data);
  return res.data.data;
}



// SITES
// User => Get Sites
export async function getSites(options={
  latestImage: false,
  device: false
}) {
  const res = await axios.get('/sites', {
    params: options
  });
  return res.data.data;
}

// User => Get Site
export async function getSite(siteId, options={
  latestImage: false,
  device: false
}) {
  const res = await axios.get(`/sites/${siteId}`, {
    params: options
  });
  return res.data.data;
}

// User => Get Public Site
export async function getPublicSite(siteId, options={
  latestImage: false,
  device: false
}) {
  const res = await axios.get(`/sites/${siteId}/public`, {
    params: options
  });
  return res.data.data;
}

// User => Update Site
export async function updateSite(siteId, data) {
  const res = await axios.put(`/sites/${siteId}`, data);
  return res.data.data;
}

// User => Site => Take Photo
export async function siteTakePhoto(siteId) {
  const res = await axios.post(`/sites/${siteId}/take-photo`);
  return res.data.data;
}


// TIMESEGMENTS
// User => Site => Get Timesegments
export async function getSiteTimesegments(siteId) {
  const res = await axios.get(`/sites/${siteId}/timesegments`);
  return res.data.data;
}

// User => Update Timesegment
export async function updateTimesegment(timesegmentId, data) {
  const res = await axios.put(`/timesegments/${timesegmentId}`, data);
  return res.data.data;
}

// User => Create Timesegment
export async function createTimesegment(data) {
  const res = await axios.post('/timesegments', data);
  return res.data.data;
}

// User => Delete Timesegment
export async function deleteTimesegment(timesegmentId) {
  const res = await axios.delete(`/timesegments/${timesegmentId}`);
  return res.data.data;
}



// SITES => IMAGES
// Site => Get Images
export async function getSiteImages(siteId, options={
  fromDate: new Date(),
  limit: 20,
  offset: 0
}) {
  const res = await axios.get(`/sites/${siteId}/images`, {
    params: {
      fromDate: options.fromDate,
      limit: options.limit,
      offset: options.offset
    }
  });
  return res.data.data;
}

// Site => Get Public Images
export async function getSitePublicImages(siteId, options={
  fromDate: new Date(),
  limit: 20,
  offset: 0
}) {
  const res = await axios.get(`/sites/${siteId}/public-images`, {
    params: {
      fromDate: options.fromDate,
      limit: options.limit,
      offset: options.offset
    }
  });
  return res.data.data;
}

// Site => Delete Images
export async function deleteSiteImages(siteId, imageIds) {
  const res = await axios.delete(`/sites/${siteId}/images`, {
    data: imageIds
  });
  return res.data.data;
}



// BUSINESSES
// User => Get Businesses
export async function getBusinesses() {
  const res = await axios.get('/businesses');
  return res.data.data;
}

// User => Get Business
export async function getBusiness(businessId) {
  const res = await axios.get(`/businesses/${businessId}`);
  return res.data.data;
}

// User => Update Business
export async function updateBusiness(businessId, data) {
  const res = await axios.put(`/businesses/${businessId}`, data);
  return res.data.data;
}

// User => Business => Get Sites
export async function getBusinessSites(businessId, options={
  latestImage: false,
  device: false
}) {
  const res = await axios.get(`/businesses/${businessId}/sites`, {
    params: options
  });
  return res.data.data;
}

// User => Business => Get Site Groups
export async function getBusinessSiteGroups(businessId) {
  const res = await axios.get(`/businesses/${businessId}/site-groups`);
  return res.data.data;
}

// User => Business => Get Members
export async function getBusienssMembers(businessId) {
  const res = await axios.get(`/businesses/${businessId}/members`);
  return res.data.data;
}



// MEMBERS
// User => Update Member
export async function updateMember(memberId, data) {
  const res = await axios.put(`/members/${memberId}`, data);
  return res.data.data;
}

// User => Delete Member
export async function deleteMember(memberId) {
  const res = await axios.delete(`/members/${memberId}`);
  return res.data.data;
}



// DEVICES
// User => Update Device
export async function updateDevice(deviceId, data) {
  const res = await axios.put(`/devices/${deviceId}`, data);
  return res.data.data;
}
